import { render } from "./HelpPage.vue?vue&type=template&id=3fd974ac&scoped=true"
import script from "./HelpPage.vue?vue&type=script&lang=js"
export * from "./HelpPage.vue?vue&type=script&lang=js"

import "./HelpPage.vue?vue&type=style&index=0&id=3fd974ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd974ac"]])

export default __exports__